/** @format */

import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";

import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from "reactstrap";

class Terms extends Component {
	constructor(props) {
		super(props);
		var html = window.T_C_US || { "Top HTML": { value: "" } };
		this.state = {
			headermenu: true,
			content: html["Top HTML"].value,
		};
		if (!getCookie("log")) {
			this.GoToPage("/");
		}
	}
	componentDidMount() {
		document.title = "Terms and Conditions";
	}
	GoToPage(path) {
		this.props.history.push(path);
	}
	render() {
		return (
			<React.Fragment>
				<Header headermenu={this.headermenu} history={this.props.history} />
				<section className='hero py-6'>
					<Container>
						<Breadcrumb className='pl-0'>
							<BreadcrumbItem>
								<a href='/home'>Home</a>
							</BreadcrumbItem>
							<BreadcrumbItem active>Terms & Conditions</BreadcrumbItem>
						</Breadcrumb>
						<div className='hero-content'>
							<h1 className='hero-heading mb-3 text-center'>Terms & Conditions</h1>
						</div>
					</Container>
				</section>
				<section className='pb-6'>
					<Container>
						<Row>
							<Col xl='12' className='text-content'>
								<div dangerouslySetInnerHTML={{ __html: this.state.content }} />
							</Col>
						</Row>
					</Container>
				</section>

				<Footer />
			</React.Fragment>
		);
	}
}
export default Terms;
